import Facebook from './Facebook';
import Instagram from './Instagram';
import Snapchat from './Snapchat';
import Telegram from './Telegram';
import Tempted from './Tempted';
import Tiktok from './Tiktok';
import Tumblr from './Tumblr';
import Twitter from './Twitter';
import Youtube from './Youtube';


export default {
  Facebook,
  Instagram,
  Snapchat,
  Telegram,
  Tempted,
  Tiktok,
  Tumblr,
  Twitter,
  Youtube,
};
